export default [
  { title: 'Бидний тухай', to: 'https://www.gegeensoft.com/about' },
  { title: 'Бүтээлүүд', to: 'https://www.gegeensoft.com/portfolios' },
  { title: 'Мэдээлэл', to: 'https://www.gegeensoft.com/services' },
  { title: 'Холбогдох', to: 'https://www.gegeensoft.com/information' }
  // { title: 'Terms', to: '#!' },
  // { title: 'Privacy', to: '#!' },
  // { title: 'Imprint', to: '#!' }
];
